import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { loadAndValidateSharedPresentation } from './game/sharedPresentationContract'
import './styles.css'
import './visual-polish.css'
import './fight-flow.css'
import './mobile-controls.css'

const mount = document.getElementById('root')
if (!mount) throw new Error('[RiftFighters] missing #root mount')
const root = ReactDOM.createRoot(mount)

function renderApp() {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

function renderContractFailure(error: unknown) {
  const message = error instanceof Error ? error.message : String(error)
  console.error('[RiftFighters] ELYON production content gate failed:', error)
  root.render(
    <main
      data-elyon-content-gate="failed"
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: 32,
        background: '#05070b',
        color: '#d7f7ff',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <section style={{ maxWidth: 720 }}>
        <p style={{ letterSpacing: '.16em', opacity: 0.72 }}>ELYON CONTENT AUTHORITY</p>
        <h1 style={{ margin: '8px 0 12px' }}>Canonical content unavailable</h1>
        <p style={{ lineHeight: 1.55, opacity: 0.82 }}>
          Rift Fighters did not start because the Elyon federation or shared presentation contract could not be proven.
          No placeholder content was substituted.
        </p>
        <pre style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', opacity: 0.58 }}>{message}</pre>
      </section>
    </main>,
  )
}

if (import.meta.env.PROD) {
  void loadAndValidateSharedPresentation().then(renderApp).catch(renderContractFailure)
} else {
  void loadAndValidateSharedPresentation().catch(error => {
    console.warn('[RiftFighters] development content contract diagnostic:', error)
  })
  renderApp()
}
